import { useLayoutEffect } from 'react';
import clsx from 'clsx';
import { Container } from '@/components/container';
import { useMainLayout } from '../';
import { PublicHeaderLogo } from '.';
import { GTranslate } from '../../../i18n';

const PublicHeader = () => {
  const { headerSticky } = useMainLayout();
  // Must run before paint so the wrapper's compensating padding-top is applied in
  // the same frame the header goes fixed — otherwise the page visibly jumps.
  useLayoutEffect(() => {
    if (headerSticky) {
      document.body.setAttribute('data-sticky-header', 'on');
    } else {
      document.body.removeAttribute('data-sticky-header');
    }
  }, [headerSticky]);
  return <header className={clsx('w-full flex items-center transition-[height] shrink-0 bg-[--tw-navbar-bg] dark:bg-coal-500 h-[--tw-header-height]', headerSticky && 'transition-[height] fixed z-10 top-0 start-0 end-0 shadow-sm backdrop-blur-md bg-white/70 dark:bg-coal-500/70 dark:border-b dark:border-b-light')}>
    <Container className="flex lg:justify-between items-center gap-2.5">
      <PublicHeaderLogo />
      {/* <HeaderSearch /> */}
      {/* <HeaderTopbar /> */}
      <div className='public-lang-switcher attorney-lang menu-default light:border-gray-300 !block !py-1 m-0 text-[10px]'>
        <GTranslate />
      </div>
    </Container>
  </header>;
};
export { PublicHeader };
